import { TeamItemComponentModule } from './../../my-teams/team-item/team-item.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { MatchFormatFormModule } from '../../matches/match-format-form/match-format-form.module';
import { CreateTieModule } from '../create-tie/create-tie.module';
import { TieScorecardModule } from '../tie-details/tie-scorecard/tie-scorecard.module';
import { TiesListPageRoutingModule } from './tie-list-routing.module';
import { TieListPage } from './tie-list.page';
import { register } from 'swiper/element/bundle';
register();

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TiesListPageRoutingModule,
        TranslateModule.forChild(),
        MatchFormatFormModule,
        EmptyPageModule,
        TieScorecardModule,
        CreateTieModule,
        TeamItemComponentModule
    ],
    declarations: [
        TieListPage
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class TiesListPageModule { }
